import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function ComercializadoraAnexo21y22RMF2026Certificado() {
  return (
    <CategoryPage
      category="comercializadoraAnexo21Y22Rmf2026Certificado2026"
      pageTitle="Certificado JSON 2026"
    />
  );
}

export default ComercializadoraAnexo21y22RMF2026Certificado;
